import React from "react";
import ReactDOM from "react-dom/client";

import "./i18n";

import App from "./App";

import { Provider } from "react-redux";
import { configureStore } from "./redux/store";
import { BrowserRouter } from "react-router-dom";

// react-redux@7's bundled component types predate React 18's stricter JSX
// component typing (a well-known incompatibility across the ecosystem at this
// version pairing) — Provider itself works fine at runtime, only its type
// signature doesn't satisfy React 18's JSX.ElementType constraint.
const ReduxProvider = Provider as unknown as React.ComponentType<{
  store: ReturnType<typeof configureStore>;
  children?: React.ReactNode;
}>;

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(

  <ReduxProvider store={configureStore({})}>
    <React.Fragment>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </React.Fragment>
  </ReduxProvider>
);